module.exports = require('./helpers/bundle-url').getBundleURL('gnRNX') + "uk-team-reports-upsell-illustration-2x.96426a53.png" + "?" + Date.now();